import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

function Header() {
  const location = useLocation();
  const [stats, setStats] = useState({ totalTracked: 0, totalRead: 0, totalUnread: 0 });

  useEffect(() => {
    // Load quick stats for header badge
    fetchQuickStats();
  }, []);

  const fetchQuickStats = async () => {
    try {
      // For MVP, we'll use placeholder data
      // In production, fetch from API
      setStats({
        totalTracked: 0,
        totalRead: 0,
        totalUnread: 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            <span className="logo-icon">📧</span>
            <span className="logo-text">MailWatch</span>
          </Link>
        </div>

        <nav className="header-nav">
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Dashboard
          </Link>
          <Link
            to="/settings"
            className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
          >
            Settings
          </Link>
        </nav>

        <div className="header-right">
          <div className="header-stats">
            <div className="stat-badge">
              <span className="stat-value">{stats.totalTracked}</span>
              <span className="stat-label">Tracked</span>
            </div>
            <div className="stat-badge read">
              <span className="stat-value">{stats.totalRead}</span>
              <span className="stat-label">Read</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
